<div class="bg-color-base-2500 h-100vh">
    <grid-row class="justify-content-center align-content-center h-100">
        <grid-col col="5" mobile="11" class="text-align-center">
                <ng-icon iconClass="icon-success-100px" width="100" height="100"></ng-icon>
                <div class="font-500 font-size-32px color-base-2200 line-h-40 mt-40">
                    {{ "YouReceiveLetter" | translate }}
                </div>
                <div class="font-400 font-size-16px color-base-700 mt-10">
                    {{ "RequestedLetterTo" | translate }} <strong>{{"mariam@email.com"}}</strong>
                </div>
                <grid-row class="justify-content-center mt-40">
                    <grid-col col="12">
                        <grid-row class="justify-content-between align-item-center">
                            <grid-col col="auto">
                                <div class="font-400 font-size-14px color-base-700">
                                    {{ "RefId" | translate }}
                                </div>
                            </grid-col>
                            <grid-col col="auto">
                                <div class="font-600 font-size-14px color-base-700">
                                    890403244322000
                                </div>
                            </grid-col>
                        </grid-row>
                    </grid-col>
                </grid-row>
            <grid-row class="justify-content-center mt-50">
                <grid-col col="8">
                    <button class="btn-dft-border">
                        {{ "Done" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </grid-col>
    </grid-row>
</div>